/* Shoe Doc — scroll reveal + section enhancements */
(function () {
  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var selector = [
      '.sd-shead',
      '.sd-intro__inner > *',
      '.sd-cond-card',
      '.sd-way-card',
      '.sd-step',
      '.sd-hero__content > *',
      '.sd-hero__media',
      '.sd-final-cta__inner > *',
      '.sd-brand'
    ].join(',');

    var els = Array.prototype.slice.call(document.querySelectorAll(selector));
    els.forEach(function (el) {
      if (!el.classList.contains('sd-reveal')) el.classList.add('sd-reveal');
    });

    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = 0;
        if (el.parentElement) {
          var sibs = Array.prototype.slice
            .call(el.parentElement.children)
            .filter(function (c) { return c.classList.contains('sd-reveal'); });
          delay = Math.min(sibs.indexOf(el), 8) * 90;
        }
        el.style.transitionDelay = delay + 'ms';
        el.classList.add('is-visible');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init); /* theme editor */
})();